import "../SystemSettings/SystemSettings.css"
import {
  closeMapUploadNotification,
  resetMapFileUploadStatus,
  uploadFile
} from "../../stores/actions/installerActions";
import { connect, useDispatch } from "react-redux";
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import AddIcon from '@material-ui/icons/Add';
import ClearIcon from '@material-ui/icons/Delete';
import Button from "@material-ui/core/Button";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CircularProgressBar from '../CircularProgressBar/CircularProgressBar';
import Fab from '@material-ui/core/Fab';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Loading from "../Loading/Loading";
import Map from "@material-ui/icons/Map";
import React from 'react';
import Snackbar from "components/Snackbar/Snackbar.js";
import { getHeaderStyle } from "../../helpers/CustomStyles";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import IconButton from "@material-ui/core/IconButton";
import SweetAlert from 'react-bootstrap-sweetalert';
import { sweetAlertStyle } from '../../helpers/CustomStyles';
import DeleteMap from "./DeleteMap";

// jenkins

const MapUpload = ({
  classes,
  mapUploadSuccessfully,
  mapUploadFailed,
  closeMapUploadNotification,
  uploadFile,
  mainMapUploadProgress,
  secondMapUploadProgress,
  thirdMapUploadProgress,
  reportMapUploadProgress,
  failedUploadMapFile,
  resetMapFileUploadStatus,
  updateParent,
  mobileView,
  mainMapWidth,
  mainMapHeight,
  secondMapDataBlob,
  thirdMapDataBlob,
  ...props
}) => {
  const [mainMapFile, setMainMapFile] = useState(null);
  const [secondMapFile, setSecondMapFile] = useState(null);
  const [thirdMapFile, setThirdMapFile] = useState(null);
  const [reportMapFile, setReportMapFile] = useState(null);
  const [isLoaderRender, setIsLoaderRender] = useState(false);
  const [smallView, setSmallView] = useState(false);
  const [secondMapInvalidDimentions, setSecondMapInvalidDimensions] = useState(false);
  const [thirdMapInvalidDimentions, setThirdMapInvalidDimensions] = useState(false);
  const [alert, setAlert] = useState(null);
  const closeNotificationTimer = useRef(null);
  const dispatch = useDispatch();

  const resetInputProgress = useCallback(() => {
    dispatch({ type: 'UPDATE_MAP_UPLOAD_PROGRESS', payload: 0 })
    dispatch({ type: 'UPDATE_SECOND_MAP_UPLOAD_PROGRESS', payload: 0 })
    dispatch({ type: 'UPDATE_THIRD_MAP_UPLOAD_PROGRESS', payload: 0 })
    dispatch({ type: 'UPDATE_REPORT_MAP_UPLOAD_PROGRESS', payload: 0 })
  }, [dispatch]);

  useEffect(() => {
    closeMapUploadNotification();
    resetInputProgress();
    resetMapFileUploadStatus();
  }, [
    closeMapUploadNotification,
    resetInputProgress,
    resetMapFileUploadStatus,
  ]);

  useLayoutEffect(() => {
    window.addEventListener("resize", onResizeSmallWindow);
    onResizeSmallWindow();
    return (() => {
      window.removeEventListener("resize", onResizeSmallWindow);
    })
  })

  useEffect(() => {
    if (mapUploadFailed || mapUploadSuccessfully) {
      setIsLoaderRender(false);
      closeNotificationTimer.current = setTimeout(() => {
        closeMapUploadNotification()
        resetInputProgress();
        setMainMapFile(null);
        setReportMapFile(null);
      }, 6000);
      if (!mobileView) {
        document.querySelector("span.MuiIconButton-label").style.transform = "translate(0px, 4px)";
      }
    }
    return (() => {
      clearTimeout(closeNotificationTimer.current)
    })
  }, [
    closeMapUploadNotification,
    mapUploadFailed,
    mapUploadSuccessfully,
    mobileView,
    resetInputProgress,
    setIsLoaderRender
  ])

  //saving map with progress bar
  const handleSaveMap = (type, map) => {
    setIsLoaderRender(true);
    let formData = new FormData();
    formData.append("systemID", props.currentSystem.ID);
    formData.append("file", map);
    formData.append("updatedViaWebsiteAt", props.systemUpdatedViaWebsiteAt);
    formData.append("mapType", type);
    uploadFile(formData, props.currentSystem.ID);
  }

  const handleDeleteMap = (type) => {
    if (type !== 'second' && type !== 'third') {
      return;
    }

    setAlert(
        <SweetAlert title=''
          key="map-removal-sweet-alert-card"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          showConfirm={false}
          style={sweetAlertStyle}>
          <DeleteMap
            systemId={props.currentSystem.ID}
            systemName={props.currentSystem.name}
            systemUpdatedViaWebsiteAt={props.systemUpdatedViaWebsiteAt}
            mapType={type}
            hideAlert={() => setAlert(null)}
            uploadFile={uploadFile}
          />
        </SweetAlert>);
  }

  const onResizeSmallWindow = () => {
    if (window.innerWidth < 480 && !smallView) {
      setSmallView(true);
    } else if (window.innerWidth >= 480 && smallView) {
      setSmallView(false);
    }
  }

  const renderButton = (type, map) => {
    const buttonStyleDesktop = { flexGrow: "1", display: "flex", justifyContent: "flex-end" }
    return (
      <>
        {isLoaderRender
          ?
          <div style={{ marginBottom: "16px", paddingLeft: "15px", paddingTop: "5px" }}>
            <Loading transform={1} height={17} width={40} color="darkGray" />
          </div >
          :
          <div style={mobileView ? {} : buttonStyleDesktop}>
            <Button
              id="saveMapParametersButton"
              className="mapButton"
              onClick={() => handleSaveMap(type, map)}
              size="large"
              disabled={mapUploadFailed || mapUploadSuccessfully || !map || type=='second' && secondMapInvalidDimentions || type=='third' && thirdMapInvalidDimentions}
              style={{ marginLeft: "5px", transition: "color 0.3s" }}
            >
              Save
            </Button>
          </div>
        }
      </>
    )
  }

  const renderMobileNotifications = () => {
    const headerStyle = getHeaderStyle(mapUploadFailed);
    const emptyHeaderStyle = { margin: smallView ? "81px 0 0 0" : "29px 0 0 0", height: "20px" };

    if (!mobileView) return null;
    if (mapUploadFailed || mapUploadSuccessfully) {
      return (
        <h5
          className={mapUploadFailed ? "notification-open-map-upload-failed" : "notification-open-map-upload-successfully"}
          style={{ ...headerStyle, marginTop: '30px' }}
        >
          {mapUploadFailed ? "Map settings were not saved" : "Map settings saved successfully"}
        </h5>
      );
    }
    return <div style={emptyHeaderStyle}></div>;
  };

  const mapNameMap = {
    "main": "view",
    "second": "roof",
    "third": "floor",
    "report": "report"
  };

  const formStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "20px",
    height: "42px",
    flexWrap: "wrap",
    transition: "0.5s"
  }

  const mapRowStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: smallView ? "100%" : "190px",
  };

  const formStyleMobile = formStyle;
  formStyleMobile.justifyContent = "flex-start";

  const inputAndLoaderWrapperStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexGrow: "1",
    padding: mobileView ? "15px 0" : "0",
    margin: mobileView ? "0" : "5px 0"
  }

  const uploadButtonStyle = {
    backgroundColor: "#00acc1",
    color: "#fff",
    width: smallView ? "100%" : "190px",
    padding: "20px",
  }
  const removeButtonStyle = {
    backgroundColor: "#ffffffff",
    color: "#da213fff",
    // width: smallView ? "100%" : "190px",
    padding: "7px",
    // filter: "drop-shadow(0px 2px 4px rgba(0,0,0,0.4))"
  }
  const CircularProgressBarWrapper = {
    display: "flex",
    flexGrow: "1",
    justifyContent: smallView ? "flex-end" : "flex-start"
  }

  const showChosenFileName = (map) => {
    let currentFileName = map ? map.name : "No file chosen";
    if (map) {
      if (currentFileName.length > 25) {
        let shortenFileName = currentFileName.substr(0, 10) + "..." + currentFileName.substr(currentFileName.length - 6, 6);
        currentFileName = shortenFileName;
      }
    }
    return (
      <div style={{ width: "120px", marginRight: "15px", textAlign: "left", marginLeft: smallView ? "15px" : "40px"}} data-testid="uploadedFileName">
        {currentFileName}
      </div>
    )
  }

    const showValidationError = (type, error) => {
      const errorElement = document.getElementById(`validation-error-${type}`);
      errorElement.innerText = error;
    }

  const checkImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        const { width, height } = img;

        URL.revokeObjectURL(objectUrl); // cleanup

        if (width === mainMapWidth && height === mainMapHeight) {
          resolve(true);
        } else {
          reject(
            new Error(
              `Invalid dimensions: ${width}x${height}. Expected ${mainMapWidth}x${mainMapHeight}`
            )
          );
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error("Invalid image file"));
      };

      img.src = objectUrl;
    });
  };

  const renderMapForm = (type, map, setter, progress, invalidDimensionsSetter) => {
    return (        
      <GridContainer>
      <GridItem xs={12} style={mobileView ? formStyleMobile : formStyle}>
        <div style={mapRowStyle} data-testid="uploadWrapper">
          <label htmlFor={`${type}-map-input`}>
            <input
              type="file"
              id={`${type}-map-input`}
              onChange={async (e) => {
                showValidationError(type, '');
                if (invalidDimensionsSetter) invalidDimensionsSetter(false);
                
                const file = e.target.files[0];
                setter(file);
                try {
                  if (type == 'second' || type == 'third' || type == 'main' && (!!secondMapDataBlob || !!thirdMapDataBlob) ) {
                    await checkImageDimensions(file);
                  }
                } catch (err) {
                  invalidDimensionsSetter(true);
                  showValidationError(type, err.message);
                }
              }}
              style={{ display: "none" }}
            />
            <Fab
              size="small"
              component="span"
              aria-label="add"
              variant="extended"
              style={uploadButtonStyle}
              data-testid="uploadButton"
            >
              <AddIcon style={{ transform: "translateX(-8px)" }} data-testid="addIcon" /> { mapNameMap[type] }
            </Fab>
          </label>
          <IconButton
            size="small"
            style={removeButtonStyle}
            onClick={() => handleDeleteMap(type)}
            disabled={type === 'main' || type === 'report' || type == 'second' && !secondMapDataBlob || type == 'third' && !thirdMapDataBlob}
          >
            <ClearIcon />
          </IconButton>
        </div>
        <div style={inputAndLoaderWrapperStyle}>
          {showChosenFileName(map)}
          <div style={CircularProgressBarWrapper}>
            {CircularProgressBar(progress, mapUploadSuccessfully, mapUploadFailed)}
          </div>
           <div id={`validation-error-${type}`} style={{color: 'red'}}></div>
          {mobileView ? "" : renderButton(type, map)}
        </div>

      </GridItem>
      {mobileView
        ?
        <GridItem xs={12}>
          {renderMobileNotifications()}
          {renderButton(type, map)}
        </GridItem>
        : ""
      }

    </GridContainer>);
  }
  return (
    <>
    {alert}
    <Card className="mapUpload" style={{ marginTop: "30px" }}>
      <CardHeader color="info" icon>
        <CardIcon color="info">
          <Map />
        </CardIcon>
        <GridItem xs={12}>
          <h4 className={classes.cardIconTitle}>Maps Upload</h4>
        </GridItem>
      </CardHeader>
      <CardBody style={{paddingBottom: "40px"}}>
        {renderMapForm('main', mainMapFile, setMainMapFile, mainMapUploadProgress)}
        {renderMapForm('second', secondMapFile, setSecondMapFile, secondMapUploadProgress, setSecondMapInvalidDimensions)}
        {renderMapForm('third', thirdMapFile, setThirdMapFile, thirdMapUploadProgress, setThirdMapInvalidDimensions)}
        {renderMapForm('report', reportMapFile, setReportMapFile, reportMapUploadProgress)}
        {!mobileView ?
          <Snackbar
            close
            closeNotification={() => closeMapUploadNotification()}
            color={mapUploadFailed ? "danger" : "success"}
            message={mapUploadFailed ? "Map settings were not saved" : "Map settings saved successfully"}
            open={mapUploadFailed || mapUploadSuccessfully}
            place="tc"
          />
          : ""
        }
      </CardBody>
    </Card>
    </>
  )
}

const mapStateToProps = state => ({
  mapUploadSuccessfully: state.installer.mapUploadSuccessfully,
  mapUploadFailed: state.installer.mapUploadFailed,
  mainMapUploadProgress: state.installer.mainMapUploadProgress,
  secondMapUploadProgress: state.installer.secondMapUploadProgress,
  thirdMapUploadProgress: state.installer.thirdMapUploadProgress,
  reportMapUploadProgress: state.installer.reportMapUploadProgress,
  failedUploadMapFile: state.installer.failedUploadMapFile,
  systemUpdatedViaWebsiteAt: state.installer.systemUpdatedViaWebsiteAt,
  mobileView: state.dashboard.mobileView,
  mainMapWidth: state.dashboard.mainMapWidth,
  mainMapHeight: state.dashboard.mainMapHeight,
  secondMapDataBlob: state.dashboard.systemSecondMapDataBlob,
  thirdMapDataBlob: state.dashboard.systemThirdMapDataBlob,
});
const actions = {
  closeMapUploadNotification,
  uploadFile,
  resetMapFileUploadStatus
}

export default connect(mapStateToProps, actions)(withStyles(regularFormsStyle)(MapUpload));